import { render, staticRenderFns } from "./ButtonCard.vue?vue&type=template&id=f0723c7a&scoped=true&"
import script from "./ButtonCard.vue?vue&type=script&lang=js&"
export * from "./ButtonCard.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCard.vue?vue&type=style&index=0&id=f0723c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0723c7a",
  null
  
)

export default component.exports